import { render, staticRenderFns } from "./EtapaRevisao.vue?vue&type=template&id=a50900e8&scoped=true"
import script from "./EtapaRevisao.vue?vue&type=script&lang=js"
export * from "./EtapaRevisao.vue?vue&type=script&lang=js"
import style0 from "./EtapaRevisao.vue?vue&type=style&index=0&id=a50900e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50900e8",
  null
  
)

export default component.exports